export default __webpack_public_path__ + "static/racing-time-990321714a0bd4c2bf5ef2ced9bc055f.png";